import "./index.css";
import PropTypes from "prop-types";

function Loader({classes}) {
  return (<div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px'
  }}>
    <div id="loading" className={classes}></div>
  </div>);
}
Loader.defaultProps = {
  classes: "",
};
Loader.propTypes = {
  classes: PropTypes.string,
};

export default Loader;
